import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { getLocationCountryQuery, getLocationCountryQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';

export const LOCATION_COUNTRY = graphql(`
  query getLocationCountry($location: String!) {
    locationCountry(location: $location)
  }
`);

export interface UseGetLocationCountry {
  location?: string;
}

export const useGetLocationCountry = (params: UseGetLocationCountry) => {
  const { location } = params;

  const variables = useMemo((): getLocationCountryQueryVariables => {
    return {
      location,
    } as getLocationCountryQueryVariables;
  }, [location]);

  const { data, error, loading } = useQuery<
    getLocationCountryQuery,
    getLocationCountryQueryVariables
  >(LOCATION_COUNTRY, {
    variables,
    skip: !location || location.length < 2,
  });

  return {
    country: data?.locationCountry,
    countryLoading: loading,
    countryError: error,
  };
};
